export const generateBookingLink = (bookingUuid: string) => {
  return `/booking-manager/${bookingUuid}/overview`;
};
